import React from 'react';
import './styles.css';

export default function EspecialLabel({label, color}) {
    return (
        <span className={`label ${color}`}>{label}</span>
    );
}